module.exports = __webpack_public_path__ + "static/media/yatay01.a5375272.jpg";